import CryptoJS from 'crypto-js';

const SIGNATURE_SECRET = 'NVPh5oo715z5DIWAeQlhMDsWXXQV4hwt';

/**
 * 酷狗 complexsearch 接口签名（与 MusicFree / yuanli 插件一致）
 * @see https://www.cnblogs.com/vergica/p/16131915.html
 */
export function buildKugouSearchUrl(keyword, page = 1, pageSize = 30) {
  const clienttime = Date.now();
  const params = {
    callback: 'callback123',
    keyword,
    page: String(page),
    pagesize: String(pageSize),
    bitrate: '0',
    isfuzzy: '0',
    tag: 'em',
    inputtype: '0',
    platform: 'WebFilter',
    userid: '-1',
    clientver: '2000',
    iscorrection: '1',
    privilege_filter: '0',
    srcappid: '2919',
    clienttime: String(clienttime),
    mid: String(clienttime),
    uuid: String(clienttime),
    dfid: '-'
  };

  const signatureParts = [
    SIGNATURE_SECRET,
    `bitrate=${params.bitrate}`,
    `callback=${params.callback}`,
    `clienttime=${params.clienttime}`,
    `clientver=${params.clientver}`,
    `dfid=${params.dfid}`,
    `inputtype=${params.inputtype}`,
    `iscorrection=${params.iscorrection}`,
    `isfuzzy=${params.isfuzzy}`,
    `keyword=${params.keyword}`,
    `mid=${params.mid}`,
    `page=${params.page}`,
    `pagesize=${params.pagesize}`,
    `platform=${params.platform}`,
    `privilege_filter=${params.privilege_filter}`,
    `srcappid=${params.srcappid}`,
    `tag=${params.tag}`,
    `userid=${params.userid}`,
    `uuid=${params.uuid}`,
    SIGNATURE_SECRET
  ];

  const signature = CryptoJS.MD5(signatureParts.join('')).toString().toUpperCase();
  const searchParams = new URLSearchParams({ ...params, signature });

  return `https://complexsearch.kugou.com/v2/search/song?${searchParams.toString()}`;
}
